import { useAppSelector } from '@store';
import ExpandableRow from './expandable-row';
import ExpandableRowContent from './expandable-row-content';
import { AmlComponentProps, RiskScoringTypes } from '../types';

const DateOfIncorporation = ({
  expandedRows,
  setExpandedRows,
  values,
  riskScoreRanges,
  isEditable,
}: AmlComponentProps) => {
  const { incorporationDates } = useAppSelector(
    (state) => state.customersDictionaries,
  );

  const currentIncorporationDateYear = Math.max(
    ...(incorporationDates
      ?.filter(
        (item) => Number(values?.dateOfIncorporation) >= Number(item.suffix),
      )
      .map((item) => Number(item.suffix)) as number[]),
  );

  const currentIncorporateDate = incorporationDates?.find(
    (item) => Number(item.suffix) === currentIncorporationDateYear,
  );

  return (
    <ExpandableRow
      name={RiskScoringTypes.DATE_ON_INCORPORATION}
      title="Date of incorporation"
      expandedRows={expandedRows}
      setExpandedRows={setExpandedRows}
      totalRisk={values?.dateOfIncorporationRisk as number}
      riskScoreRanges={riskScoreRanges}

      // comments={[]}
      // onSend={onSend}
      // onDelete={onDelete}
    >
      <ExpandableRowContent
        value={currentIncorporateDate?.value as string}
        risk={
          values?.dateOfIncorporationRisk?.toString() !== 'null' &&
          values?.dateOfIncorporationRisk?.toString() !== 'undefined'
            ? (values?.dateOfIncorporationRisk?.toString() as string)
            : '-'
        }
        list={incorporationDates}
        name="channel"
        isEditable={isEditable}
      />
    </ExpandableRow>
  );
};

export default DateOfIncorporation;
